/* ==========================================================
   UNHATTAR FACE CUSTOMIZER — garment templates
   All shapes are drawn on a 1000 x 1000 artboard.
   - path:   garment contour (also the printable mask)
   - bbox:   [x, y, w, h] bounding box of the printable area
   - details: seam / band / string strokes drawn on top
   - print:  production print spec. null = "needs production setup"
             e.g. { widthMM: 300, heightMM: 250, dpi: 300, bleedMM: 3 }
   To add a garment: add an entry here and link a product to it in
   the "Unhattar face customizer" section (or tag it customizer-<key>).
   ========================================================== */
window.UH_GARMENTS = {
  bikini: {
    name: 'Bikini',
    views: {
      front: {
        label: 'Front',
        path: 'M265 330 C300 250 350 180 382 150 C412 190 442 258 472 330 Z M528 330 C558 258 588 190 618 150 C650 180 700 250 735 330 Z M262 520 L738 520 L724 600 C680 642 602 720 560 822 L440 822 C398 720 320 642 276 600 Z',
        bbox: [262, 150, 476, 672],
        details: [
          { d: 'M190 338 L810 338', w: 7 },
          { d: 'M382 150 L445 40 M618 150 L555 40', w: 5 },
          { d: 'M262 520 L210 548 M738 520 L790 548', w: 6 },
          { d: 'M262 532 L738 532', w: 3, a: 0.35 }
        ]
      },
      back: {
        label: 'Back',
        path: 'M210 318 L790 318 L790 352 L210 352 Z M252 500 L748 500 L752 600 C716 700 650 790 560 846 L440 846 C350 790 284 700 248 600 Z',
        bbox: [210, 318, 580, 528],
        details: [
          { d: 'M252 500 L200 528 M748 500 L800 528', w: 6 },
          { d: 'M252 512 L748 512', w: 3, a: 0.35 },
          { d: 'M500 120 L500 318', w: 5 }
        ]
      }
    },
    defaultBg: '#FDE7EC',
    print: null
  },

  thong: {
    name: 'Thong',
    views: {
      front: {
        label: 'Front',
        path: 'M228 300 L772 300 C744 382 644 482 546 692 L454 692 C356 482 256 382 228 300 Z',
        bbox: [228, 300, 544, 392],
        details: [ { d: 'M228 318 L772 318', w: 4, a: 0.4 } ]
      },
      back: {
        label: 'Back',
        path: 'M300 300 L700 300 C640 362 562 424 516 646 L484 646 C438 424 360 362 300 300 Z M150 300 L850 300 L850 318 L150 318 Z',
        bbox: [300, 300, 400, 346],
        details: [ { d: 'M150 309 L850 309', w: 3, a: 0.4 } ]
      }
    },
    defaultBg: '#FFFFFF',
    print: null
  },

  briefs: {
    name: 'Briefs',
    views: {
      front: {
        label: 'Front',
        path: 'M220 300 L780 300 L762 420 C702 470 600 560 560 702 L440 702 C400 560 298 470 238 420 Z',
        bbox: [220, 300, 560, 402],
        details: [
          { d: 'M222 336 L778 336', w: 4, a: 0.45 },
          { d: 'M762 420 C702 470 600 560 560 702 M238 420 C298 470 400 560 440 702', w: 3, a: 0.3 }
        ]
      },
      back: {
        label: 'Back',
        path: 'M220 300 L780 300 L776 452 C720 562 640 682 560 732 L440 732 C360 682 280 562 224 452 Z',
        bbox: [220, 300, 560, 432],
        details: [ { d: 'M222 336 L778 336', w: 4, a: 0.45 } ]
      }
    },
    defaultBg: '#FFFFFF',
    print: null
  },

  onepiece: {
    name: 'One-piece swimsuit',
    views: {
      front: {
        label: 'Front',
        path: 'M340 100 L400 100 C412 190 442 242 500 252 C558 242 588 190 600 100 L660 100 C672 262 692 382 682 472 C672 562 700 642 742 702 C662 722 582 782 546 882 L454 882 C418 782 338 722 258 702 C300 642 328 562 318 472 C308 382 328 262 340 100 Z',
        bbox: [258, 100, 484, 782],
        details: [ { d: 'M258 702 C338 722 418 782 454 882 M742 702 C662 722 582 782 546 882', w: 3, a: 0.35 } ]
      },
      back: {
        label: 'Back',
        path: 'M340 100 L400 100 C420 300 452 382 500 392 C548 382 580 300 600 100 L660 100 C672 262 692 382 682 472 C672 562 700 662 742 722 C660 772 600 842 560 892 L440 892 C400 842 340 772 258 722 C300 662 328 562 318 472 C308 382 328 262 340 100 Z',
        bbox: [258, 100, 484, 792],
        details: []
      }
    },
    defaultBg: '#FDE7EC',
    print: null
  },

  trunks: {
    name: "Men's swim trunks",
    views: {
      front: {
        label: 'Front',
        path: 'M250 220 L750 220 L792 702 L562 722 L522 522 C512 500 488 500 478 522 L438 722 L208 702 Z',
        bbox: [208, 220, 584, 502],
        details: [
          { d: 'M252 268 L748 268', w: 5, a: 0.45 },
          { d: 'M485 268 L470 380 M515 268 L530 380', w: 4 },
          { d: 'M500 268 L500 500', w: 2, a: 0.3 }
        ]
      },
      back: {
        label: 'Back',
        path: 'M250 220 L750 220 L792 702 L562 722 L522 532 C512 512 488 512 478 532 L438 722 L208 702 Z',
        bbox: [208, 220, 584, 502],
        details: [ { d: 'M252 268 L748 268', w: 5, a: 0.45 }, { d: 'M500 268 L500 520', w: 2, a: 0.3 } ]
      }
    },
    defaultBg: '#FFFFFF',
    print: null
  },

  couple: {
    name: 'Matching couple swimwear',
    views: {
      her: {
        label: 'Her bikini',
        path: 'M265 330 C300 250 350 180 382 150 C412 190 442 258 472 330 Z M528 330 C558 258 588 190 618 150 C650 180 700 250 735 330 Z M262 520 L738 520 L724 600 C680 642 602 720 560 822 L440 822 C398 720 320 642 276 600 Z',
        bbox: [262, 150, 476, 672],
        details: [
          { d: 'M190 338 L810 338', w: 7 },
          { d: 'M382 150 L445 40 M618 150 L555 40', w: 5 },
          { d: 'M262 520 L210 548 M738 520 L790 548', w: 6 }
        ]
      },
      his: {
        label: 'His trunks',
        path: 'M250 220 L750 220 L792 702 L562 722 L522 522 C512 500 488 500 478 522 L438 722 L208 702 Z',
        bbox: [208, 220, 584, 502],
        details: [
          { d: 'M252 268 L748 268', w: 5, a: 0.45 },
          { d: 'M485 268 L470 380 M515 268 L530 380', w: 4 }
        ]
      }
    },
    defaultBg: '#FDE7EC',
    print: null
  }
};
